import { Link, useParams } from 'react-router-dom';
import { hotArticles } from '@/mocks';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ArticlePage() {
  const { slug } = useParams();
  const article = hotArticles.find((a) => a.slug === slug) || hotArticles[0];
  const relatedArticles = hotArticles.filter((a) => a.id !== article.id).slice(0, 4);

  const breadcrumbLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
      { '@type': 'ListItem', position: 2, name: article.category, item: `/category/${article.categorySlug}` },
      { '@type': 'ListItem', position: 3, name: article.title, item: `/article/${article.slug}` },
    ],
  };

  const articleLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.summary,
    image: article.image,
    datePublished: article.publishDate,
    author: { '@type': 'Organization', name: '51吃瓜网站' },
    publisher: { '@type': 'Organization', name: '51吃瓜网站', logo: { '@type': 'ImageObject', url: '/vite.svg' } },
    articleSection: article.category,
    inLanguage: 'zh-CN',
  };

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '该爆料的真实性如何？', acceptedAnswer: { '@type': 'Answer', text: '本文内容基于多方信源整理，所有关键信息均经过交叉验证。我们鼓励读者理性看待，以官方通报为准。' } },
      { '@type': 'Question', name: '如何获取最新进展？', acceptedAnswer: { '@type': 'Answer', text: '请关注51吃瓜网站首页及对应分类频道，我们将第一时间更新事件最新进展。' } },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <article className="py-8 md:py-12">
          <div className="container-custom max-w-4xl">
            <nav aria-label="面包屑导航" className="mb-4 md:mb-6">
              <ol className="flex items-center gap-2 text-sm text-foreground-500">
                <li><Link to="/" className="hover:text-primary-600 transition-colors">首页</Link></li>
                <li><i className="ri-arrow-right-s-line text-xs" /></li>
                <li><Link to={`/category/${article.categorySlug}`} className="hover:text-primary-600 transition-colors">{article.category}</Link></li>
                <li><i className="ri-arrow-right-s-line text-xs" /></li>
                <li className="text-foreground-700 truncate max-w-[200px]">{article.title}</li>
              </ol>
            </nav>

            <header className="mb-6 md:mb-8">
              <div className="flex items-center gap-2 mb-3 flex-wrap">
                <span className="px-2.5 py-1 rounded-md bg-primary-500/10 text-primary-600 text-xs font-medium">{article.category}</span>
                {article.hot && <span className="px-2.5 py-1 rounded-md bg-accent-500/10 text-accent-600 text-xs font-medium flex items-center gap-1"><i className="ri-fire-line" /> 热门</span>}
              </div>
              <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 leading-tight mb-3">{article.title}</h1>
              <div className="flex items-center gap-4 text-sm text-foreground-500">
                <span>{article.publishDate}</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line" /> {article.views.toLocaleString()}</span>
              </div>
            </header>

            <div className="rounded-2xl overflow-hidden mb-6 md:mb-8">
              <img src={article.image} alt={article.title} className="w-full aspect-video object-cover object-top" loading="eager" />
            </div>

            <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed">
              <p className="text-base md:text-lg text-foreground-600 font-medium mb-4">{article.summary}</p>
              <p className="mb-4">据51吃瓜网站独家消息，该事件经多方渠道核实，目前已获得大量实锤证据。本文将为您全面梳理事件始末，还原真相。</p>
              <h2 className="text-lg md:text-xl font-bold text-foreground-950 mt-6 mb-3">事件回顾</h2>
              <p className="mb-4">事件最初源于某社交平台的匿名爆料帖，随后迅速引发网友关注。经过51吃瓜网站的持续追踪与多方核实，更多细节逐渐浮出水面。根据知情人士透露，该事件牵涉范围之广、影响之大，远超外界预期。</p>
              <p className="mb-4">截至目前，相关话题已在多个社交平台累计获得超过{article.views.toLocaleString()}次浏览，评论区讨论热烈。不少网友表示震惊，也有人称"早有预感"。</p>
              <h2 className="text-lg md:text-xl font-bold text-foreground-950 mt-6 mb-3">实锤证据</h2>
              <p className="mb-4">51吃瓜网站已通过独家渠道获取了与该事件相关的关键证据材料。包括聊天记录截图、现场照片以及相关视频片段。这些证据材料的真实性已经过专业团队交叉验证。</p>
              <p className="mb-4">我们将持续关注事件后续发展，第一时间为您带来最新进展。敬请关注51吃瓜网站，获取更多独家爆料资讯。</p>
              <div className="bg-primary-50 border border-primary-200 rounded-xl p-4 md:p-6 mt-6 mb-4">
                <p className="text-sm text-primary-800 font-medium mb-1">温馨提示</p>
                <p className="text-sm text-primary-700">以上内容基于多方信源整理，仅供参考。如有出入，请以官方通报为准。51吃瓜网站致力于提供真实、客观的娱乐资讯，坚决反对造谣传谣。</p>
              </div>
            </div>

            <section className="mt-8 md:mt-10 pt-6 md:pt-8 border-t border-background-200" aria-label="文章FAQ">
              <h2 className="text-lg font-semibold text-foreground-950 mb-4">常见问题</h2>
              <div className="flex flex-col gap-3">
                <details className="group rounded-xl border border-background-200 bg-background-100 overflow-hidden">
                  <summary className="flex items-center justify-between gap-4 p-4 text-sm font-medium text-foreground-800 cursor-pointer list-none">
                    <span>该爆料的真实性如何？</span>
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 text-xs group-open:rotate-180 transition-transform"><i className="ri-arrow-down-s-line" /></span>
                  </summary>
                  <div className="px-4 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">本文内容基于多方信源整理，所有关键信息均经过交叉验证。我们鼓励读者理性看待，以官方通报为准。</p>
                  </div>
                </details>
                <details className="group rounded-xl border border-background-200 bg-background-100 overflow-hidden">
                  <summary className="flex items-center justify-between gap-4 p-4 text-sm font-medium text-foreground-800 cursor-pointer list-none">
                    <span>如何获取最新进展？</span>
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 text-xs group-open:rotate-180 transition-transform"><i className="ri-arrow-down-s-line" /></span>
                  </summary>
                  <div className="px-4 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">请关注51吃瓜网站首页及对应分类频道，我们将第一时间更新事件最新进展。</p>
                  </div>
                </details>
              </div>
            </section>

            <section className="mt-8 md:mt-10 pt-6 md:pt-8 border-t border-background-200">
              <h3 className="text-lg font-semibold text-foreground-950 mb-4">相关推荐</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                {relatedArticles.map((related) => (
                  <Link key={related.id} to={`/article/${related.slug}`} className="flex items-start gap-3 p-3 rounded-xl bg-background-100 hover:bg-background-200 transition-colors group">
                    <div className="w-20 h-20 rounded-lg overflow-hidden flex-shrink-0">
                      <img src={related.image} alt={related.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform" loading="lazy" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2">{related.title}</h4>
                      <span className="text-xs text-foreground-400 mt-1 block">{related.category}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          </div>
        </article>
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }} />
    </div>
  );
}